<!--
    电池状态/历史状态曲线
-->

<template>
    <div id="history-curve">
        <v-ws v-on:onopen="initSearch" :sendMessage="sendMessage" v-on:vehicle_search="changeSearchData" ></v-ws>
        <el-popover
          ref="popover"
          placement="right"
          width="540"
          trigger="click"
          v-model="visible"
          >
            <div class="pover-search">
                <v-search
                    v-on:select="searchSelectCurrent"
                    v-on:search="createVehicleSearch"
                    :serchData="serchData"
                    :showConfirmBt='true'
                    v-on:cancelSelect="cancelSelect">
                </v-search>
            </div>
        </el-popover>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="电池系统" name="first">
                <el-row>
                  <el-col :span="12">
                    <p class="setting-title car">车辆选择</p>
                    <el-button type="primary" v-popover:popover>选择车辆</el-button>
                    <table class="car-table" cellspacing="0" cellpadding="0" >
                      <tr>
                        <td colspan="1" rowspan="2">当前车辆</td>
                        <td>电池编码</td>
                        <td>车牌号码</td>
                        <td>厂家车辆编号</td>
                      </tr>
                      <tr>
                        <td>A00001</td>
                        <td>粤B-00001</td>
                        <td>111158</td>
                      </tr>
                    </table>
                  </el-col>
                  <el-col :span="12">
                    <p class="setting-title time">时间选择</p>
                    <v-datepicker></v-datepicker>
                  </el-col>
                </el-row>
                <div class="chart-slave">
                    <v-chart v-bind:option="option" idChart="testChart2"></v-chart>
                </div>
            </el-tab-pane>
            <el-tab-pane label="单体系统" name="second">
                <el-row>
                  <el-col :span="12">
                    <p class="setting-title car">车辆选择</p>
                    <el-button type="primary" v-popover:popover>选择车辆</el-button>
                    <table class="car-table" cellspacing="0" cellpadding="0" >
                      <tr>
                        <td colspan="1" rowspan="2">当前车辆</td>
                        <td>电池编码</td>
                        <td>车牌号码</td>
                        <td>厂家车辆编号</td>
                      </tr>
                      <tr>
                        <td>A00001</td>
                        <td>粤B-00001</td>
                        <td>111158</td>
                      </tr>
                    </table>
                    <p class="setting-title time">时间选择</p>
                    <v-datepicker></v-datepicker>

                  </el-col>
                  </el-col>
                  <el-col :span="12">
                    <p class="setting-title time">从控选择</p>
                    <el-popover
                      ref="popover4"
                      placement="right"
                      width="346"
                      trigger="click">
                      <el-table :data="slaveData">
                        <el-table-column
                            label=""
                            width="36">
                            <template scope="scope">
                                <el-radio class="radio" v-model="radioSlave" :label="scope.row.id"></el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column width="100" property="id" label="从控序号"></el-table-column>
                        <el-table-column width="100" property="number" label="电芯数量"></el-table-column>
                        <el-table-column width="100" property="range" label="编号范围"></el-table-column>
                      </el-table>
                    </el-popover>
                    <el-input
                      class="slave-module"
                      placeholder="选择从控"
                      icon="menu"
                      v-model="slaveModule"
                      readonly="readonly"
                      v-popover:popover4>
                    </el-input>

                    <p class="setting-title time">指标选择</p>
                    <el-radio class="radio" v-model="radioTarget" label="1">电压</el-radio>
                    <el-radio class="radio" v-model="radioTarget" label="2">均衡</el-radio>

                  </el-col>
                </el-row>
                <div class="chart-slave">
                    <v-chart v-bind:option="option" idChart="testChart"></v-chart>
                </div>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>
<script>
import chart from '../plugins/chart';
import datepicker from '../plugins/date-picker';
import search from '../plugins/search';
import ws from '../plugins/ws';
export default {
    name: 'history-curve',
    created () {
        this.option = {
            title: {
                text: 'ECharts 入门示例'
            },
            tooltip: {},
            legend: {
                data: ['销量']
            },
            xAxis: {
                data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
            },
            yAxis: {},
            series: [{
                name: '销量',
                type: 'bar',
                data: [5, 20, 36, 10, 10, 20]
            }]
        };
    },
    data () {
        return {
            activeName: 'first',
            slaveModule: '从控1',
            slaveData: [
                {
                    id: '从控1',
                    number: 2,
                    range: '1-8'
                },
                {
                    id: '从控2',
                    number: 3,
                    range: '9-11'
                }
            ],
            radioSlave: '从控1',
            radioTarget: '1',
            option: {},
            visible: false,
            sendMessage: {},
            serchData: {}
        };
    },
    components: {
        'v-chart': chart,
        'v-search': search,
        'v-ws': ws,
        'v-datepicker': datepicker
    },
    methods: {
        handleClick (tab, event) {
            console.log('click', tab, event);
            this.option = {
                title: {
                    text: 'ECharts 入门示例'
                },
                tooltip: {},
                legend: {
                    data: ['销量']
                },
                xAxis: {
                    data: ['衬衫', '羊毛衫', '雪纺衫', '裤子', '高跟鞋', '袜子']
                },
                yAxis: {},
                series: [{
                    name: '销量',
                    type: 'bar',
                    data: [100, 20, 36, 10, 10, 20]
                }]
            };
        },
        createVehicleSearch (value) {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: value
            };
        },
        changeSearchData (data) {
            this.serchData = data;
        },
        initSearch () {
            this.sendMessage = {
                topic: 'vehicle_search',
                action: 'create',
                data: {
                    battery_code: '',
                    plate_number: '',
                    production_vehicle_no: ''
                }
            };
        },
        searchSelectCurrent (car) {
        },
        cancelSelect () {
            this.visible = false;
        }

    }
};
</script>
<style scoped>
#history-curve{
    background-color: #fff;
}
.el-button--primary{
    width: 90px;
    position: absolute;
    top:0;
    left: 475px;
}
.el-tabs{
    text-align: left;
}
.slave-module{
    max-width: 254px;
}
.chart-slave{
    height: 500px;
    width: 700px;
}
</style>



// WEBPACK FOOTER //
// history-curve.vue?7d256df1